import { useCallback, useContext } from 'react';
import context from './index';

const useSelection = () => {
  const { state, setState } = useContext(context);

  /**
   * Sets the selection in state
   */
  const setSelection = useCallback((selectionOrFn) => {
    setState(ps => ({
      ...ps,
      selection: typeof selectionOrFn === 'function'
        ? selectionOrFn(ps.selection)
        : selectionOrFn,
    }));
  }, []);

  return [state.selection, setSelection];
}

export default useSelection;